import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadPerformanceMetricsEpic } from './_epics/loadPerformanceMetrics.epic';

export const performanceMetricsEpic = safeCombineEpics(
  loadPerformanceMetricsEpic,
);
